// extracted by mini-css-extract-plugin
export default {"listWrapper":"_5a9a059e","swiperItem":"_2de130"};